import { useClassPerfQuestions } from '../../../api/hooks';
import { EmptyState, PanelCard } from '../../../components/ui';
import Spinner from '../../../components/ui/Spinner';
import ErrorPanel from '../../../components/ui/ErrorPanel';
import { FaClipboardList } from '../../../components/ui/icons';
import QuestionsTable from '../components/QuestionsTable';

interface Props {
  gradeId: number;
  sectionId: number | 'all';
  subjectId: number | 'all';
  weeks?: number;
}

/** The backend's default `min_attempts` for most-missed questions. */
const MIN_ATTEMPTS = 5;

export default function QuestionsTab({ gradeId, sectionId, subjectId, weeks }: Props) {
  const q = useClassPerfQuestions({
    grade: gradeId, section: sectionId, subject: subjectId, weeks,
  });
  if (q.isLoading) return <div className="flex justify-center py-8"><Spinner size="md" /></div>;
  if (q.isError || !q.data) return <ErrorPanel />;
  if (q.data.questions.length === 0) {
    return <PanelCard><EmptyState icon={<FaClipboardList />} title="No questions yet"
      body="No questions with enough attempts yet." /></PanelCard>;
  }
  return (
    <PanelCard title="Most-missed questions" help="most_missed" align="end"
      subtitle="Open a question to see how students split across the options."
      actions={<span className="text-xs text-muted">Questions with {MIN_ATTEMPTS}+ attempts</span>}>
      <QuestionsTable questions={q.data.questions} />
    </PanelCard>
  );
}
